import { useQuery } from "@tanstack/react-query";
import { WarehouseCheckInService } from "src/services";
import { APIError } from "src/errors";
import { queryKeys } from "src/constants";
import { ISOString } from "src/types";

const useWarehouseCheckIn = (
  warehouseCheckInId: string,
  timestamp: ISOString,
  warehouseCheckInService: WarehouseCheckInService
) => {
  const {
    data: warehouseCheckIn,
    error: fetchError,
    isLoading,
    refetch
  } = useQuery({
    queryKey: queryKeys.warehouseCheckIn(warehouseCheckInId, timestamp),
    queryFn: async () => {
      try {
        return await warehouseCheckInService.getWarehouseCheckInById(warehouseCheckInId, timestamp);
      } catch (error) {
        if (error instanceof APIError && error.statusCode === 404) {
          return null;
        }
        throw error;
      }
    },
    enabled: !!warehouseCheckInId,
    retry: false
  });
  return { warehouseCheckIn, fetchError, isLoading, refetch };
};

export { useWarehouseCheckIn };
